module.exports = __webpack_public_path__ + "static/media/process_4.7c70dcdc.png";